import React from "react";
import axios from "axios";

export const updateUserProfileApi = async (id,token,data) => {

  try {
    const options = {
      method: "PUT",
      url : `https://visapro-api.tcore.online/api/v1/users/${id}`,
      headers: {
        'Authorization': `Basic ${token}` 
      },
      data: data,
    };
    const response = await axios.request(options)
    const update = {
      data: response.data,
    };
    return update;
  } catch (error) {
    const update = {
      error: error,
    };
    return update;
  }
};
